import { tv } from "./tw"

export const brandVariants = tv({
  base: "bg-bg text-fg theme-light",
  variants: {
    theme: {
      orange: "bg-orange",
      grey: "theme-dark bg-bg-mid",
      white: "bg-white",
      // coral: "bg-coral",
      // blue: "bg-blue",
      // green: "bg-green",
      // lavender: "bg-lavender",
    },
  },
})
